import PropTypes from "prop-types";
import styles from "./ControlsHeader.module.css";

/**
 * View component. Displays a bar with header text on the left and custom controls on the right.
 */
export function ControlsHeader({ title, children }) {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title ?? ""}</h2>
      <div className={styles.controls}>{children}</div>
    </div>
  );
}

ControlsHeader.propTypes = {
  /**
   * Header text
   */
  title: PropTypes.string,

  /**
   * Controls
   */
  children: PropTypes.node,
};
